export default __webpack_public_path__ + "static/media/Mark-4-HUD-Targeting (Selector Ring).3e460cf2.jpg";